/**
 * 点几何坐标转换方法.
 * @param   {Object}   geometry    几何对象
 * @param   {Function} convertFunc 点几何转换函数
 * @returns {Object} 坐标转换后的几何对象
 */
function _convertPoint(geometry, convertFunc) {
    const point = convertFunc(geometry.x, geometry.y);
    geometry.x = point.x;
    geometry.y = point.y;

    return geometry;
}

/**
 * 线几何坐标转换方法.
 * @param   {Object}   geometry    几何对象
 * @param   {Function} convertFunc 点几何转换函数
 * @returns {Object} 坐标转换后的几何对象
 */
function _convertLineString(geometry, convertFunc) {
    geometry.coordinates = geometry.coordinates.map(element => _convertPoint(element, convertFunc));
    return geometry;
}

/**
 * 面几何坐标转换方法.
 * @param   {Object}   geometry    几何对象
 * @param   {Function} convertFunc 点几何转换函数
 * @returns {Object} 坐标转换后的几何对象
 */
function _convertPolygon(geometry, convertFunc) {
    geometry.coordinates = geometry.coordinates.map(element => _convertLineString(element, convertFunc));
    return geometry;
}

/**
 * 遍历geometry对象，根据几何类型使用给定的方法转换坐标，不会改变原对象.
 * @param   {Object}   geometry    几何对象
 * @param   {Function} convertFunc 点几何转换函数
 * @returns {Object} 坐标转换后的几何对象
 */
function convert(geometry, convertFunc) {
    const newGeometry = geometry.clone();
    const type = newGeometry.type;
    switch (type) {
        case 'Point':
            return _convertPoint(newGeometry, convertFunc);
        case 'LineString':
            return _convertLineString(newGeometry, convertFunc);
        case 'Polygon':
            return _convertPolygon(newGeometry, convertFunc);
        default:
            throw new Error(`不支持的类型:${type}`);
    }
}

export default {
    convert
};
